import React from 'react'
import { gql } from '@apollo/client'
import { useMutation } from '@ztechapps/common.hook'
import { cartFragment } from '../graphql'
import type { UseCommonCartProps } from '../type'
import type { Order, UpdateToCartArgs } from '@ztechapps/common.contract'

export const buildOrderUpdateToCartQuery = (fragment: string) => {
  return gql`
  mutation orderUpdateToCart($input: UpdateToCartArgs!) {
    orderUpdateToCart(input: $input) {
        _id
       ${fragment}
    }
  }
`
}

const orderUpdateToCartQuery = buildOrderUpdateToCartQuery(cartFragment)

export const useUpdateToCart = ({ validate, query, ...rest }: UseCommonCartProps = {}) => {
  const [onUpdate, , { loading, error }] = useMutation<{ orderUpdateToCart: Order }, UpdateToCartArgs>({
    query: query ?? orderUpdateToCartQuery,
    ...rest,
  })

  const updateToCart = React.useCallback(
    ({ itemId, orderId, quantity }) => {
      validate?.()

      //do the submission here
      const input = {
        orderId,
        itemId,
        quantity,
      }

      return onUpdate({ input })
    },
    [onUpdate, validate]
  )

  return { updateToCart, loading, error }
}
